// assets/jonbit-comparison.js

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', e => {
    // 1) Tab switching
    let tabBtn = e.target.closest('.comparison-tab-btn');
    if (tabBtn) {
      let section = tabBtn.closest('[id^="comparison-section-"]');
      let allBtns = section.querySelectorAll('.comparison-tab-btn');
      let allContents = section.querySelectorAll('.comparison-tab-content');

      allBtns.forEach(b => b.classList.remove('active'));
      tabBtn.classList.add('active');

      allContents.forEach(c => c.classList.remove('active'));
      let target = section.querySelector('#' + tabBtn.dataset.target);
      if (target) target.classList.add('active');
      return;
    }

    // 2) Feature expand/collapse
    let feature = e.target.closest('.feature-item');
    if (feature && feature.dataset.toggle) {
      let section = feature.closest('[id^="comparison-section-"]');
      let detail = section.querySelector('#' + feature.dataset.toggle);
      feature.classList.toggle('open');
      if (detail) detail.classList.toggle('active');
    }
  });
});
